module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-from-bottom"
    }
  }, [(_vm.visible) ? _c('aside', {
    ref: "backdrop",
    staticClass: "p-modal-backdrop",
    on: {
      "click": function($event) {
        _vm.eventHide($event)
      }
    }
  }, [_c('div', {
    staticClass: "p-modal-container"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00382d5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/modal.vue
// module id = 28
// module chunks = 0